import axios from 'axios'
import Qs from 'qs'
import store from './store'
import router from './router'

//设置全局axios默认值
axios.defaults.timeout = 5000; //5000的超时验证

//创建一个axios实例
const instance = axios.create({
    //config里面有这个transformRquest，这个选项会在发送参数前进行处理。
    //这时候我们通过Qs.stringify转换为表单查询参数
    transformRequest: [function (data) {
        data = Qs.stringify(data);
        return data;
    }],
    //设置Content-Type
    headers:{'Content-Type':'application/x-www-form-urlencoded'}
});

axios.interceptors.request.use = instance.interceptors.request.use;

//request拦截器
instance.interceptors.request.use(
    config => {
        //每次发送请求之前检测都vuex存有token,那么都要放在请求头发送给服务器
        if(store.state.token){
            config.headers.Authorization = store.state.token;
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);
//respone拦截器
instance.interceptors.response.use(
    response => {
        return response;
    },
    error => { //默认除了2XX之外的都是错误的，就会走这里
        if(error.response){
            switch(error.response.status){
                case 401:
                    store.dispatch('UserLogout'); //可能是token过期，清除它
                    router.replace({ //跳转到登录页面
                        path: 'login',
                        query: { redirect: router.currentRoute.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                    });
            }
        }
        return Promise.reject(error.response);
    }
);

let host = 'www.bridgetek.cn';

export default {
    //用户登录
    userLogin(data){
        return instance.post(host + '/login', data);
    },
    deleteNews(data){
        return instance.post(host+'/news/delete',data);
    },
    getNewsList(data){
        return instance.post(host + '/news/list', data);
    },
    getAdminNewsList(data){
        return instance.post(host + '/news/admin/list', data);
    },
    addViews(data){
        //新闻浏览数+1
        return instance.post(host + '/news/addViews', data);
    }
}



// WEBPACK FOOTER //
// ./src/axios.js